import { AgentShell } from "@/components/layout/AgentShell";
import { AppShell } from "@/components/layout/AppShell";
import { DocsLayout } from "@/components/layout/DocsLayout";
import { AgentHuntHost } from "@/hooks/useAgentHuntScanner";
import { ROUTES } from "@/lib/routes";
import AgentsPage from "@/pages/AgentsPage";
import AnalyticsPage from "@/pages/AnalyticsPage";
import BorrowPage from "@/pages/BorrowPage";
import CyclesPage from "@/pages/CyclesPage";
import DashboardPage from "@/pages/DashboardPage";
import DocsArticlePage from "@/pages/docs/DocsArticlePage";
import DocsHomePage from "@/pages/docs/DocsHomePage";
import GovernancePage from "@/pages/GovernancePage";
import InstitutionsPage from "@/pages/InstitutionsPage";
import IntelligencePage from "@/pages/IntelligencePage";
import LiquidationPage from "@/pages/LiquidationPage";
import LiquidityPage from "@/pages/LiquidityPage";
import MmkBookPage from "@/pages/MmkBookPage";
import MorePage from "@/pages/MorePage";
import MotokoDollarPage from "@/pages/MotokoDollarPage";
import MotokoMakerPage from "@/pages/MotokoMakerPage";
import ExploreMmkPage from "@/pages/ExploreMmkPage";
import ExploreUsdmPage from "@/pages/ExploreUsdmPage";
import OraclePage from "@/pages/OraclePage";
import PegSwapPage from "@/pages/PegSwapPage";
import ProfilePage from "@/pages/ProfilePage";
import PortfolioPage from "@/pages/PortfolioPage";
import SavingsPage from "@/pages/SavingsPage";
import SkillsPage from "@/pages/SkillsPage";
import TreasuryPage from "@/pages/TreasuryPage";
import VaultDetailPage from "@/pages/VaultDetailPage";
import VaultsPage from "@/pages/VaultsPage";
import WalletPage from "@/pages/WalletPage";
import { Navigate, Route, Routes } from "react-router-dom";

export default function App() {
	return (
		<>
		<AgentHuntHost />
		<Routes>
			{/* DeFi platform shell */}
			<Route element={<AppShell />}>
				<Route index element={<Navigate to={ROUTES.borrow} replace />} />
				<Route path="portfolio" element={<PortfolioPage />} />
				<Route path="dashboard" element={<DashboardPage />} />
				<Route path="more" element={<MorePage />} />
				<Route path="motokomaker" element={<MotokoMakerPage />} />
				<Route path="motokodollar" element={<MotokoDollarPage />} />
				<Route path="borrow" element={<BorrowPage />} />
				<Route path="vaults" element={<VaultsPage />} />
				<Route path="vaults/:vaultId" element={<VaultDetailPage />} />
				<Route path="treasury" element={<TreasuryPage />} />
				<Route path="pegswap" element={<PegSwapPage />} />
				<Route path="mmk-book" element={<MmkBookPage />} />
				<Route path="liquidity" element={<LiquidityPage />} />
				<Route path="liquidation" element={<LiquidationPage />} />
				<Route path="governance" element={<GovernancePage />} />
				<Route path="wallet" element={<WalletPage />} />
				<Route path="savings" element={<SavingsPage />} />
				<Route path="profile" element={<ProfilePage />} />
				<Route path="analytics" element={<AnalyticsPage />} />
				<Route path="oracle" element={<OraclePage />} />
				<Route path="cycles" element={<CyclesPage />} />
				<Route path="institutions" element={<InstitutionsPage />} />
				<Route path="explore/usdm" element={<ExploreUsdmPage />} />
				<Route path="explore/mmk" element={<ExploreMmkPage />} />
			</Route>

			{/* Agent Layer mode — dark secondary menu */}
			<Route element={<AgentShell />}>
				<Route path="agents" element={<AgentsPage />} />
				<Route path="skills" element={<SkillsPage />} />
				<Route path="intelligence" element={<IntelligencePage />} />
			</Route>

			{/* Documentation layer — academic chrome */}
			<Route path="docs" element={<DocsLayout />}>
				<Route index element={<DocsHomePage />} />
				<Route path=":sectionId/:slug" element={<DocsArticlePage />} />
			</Route>

			<Route path="*" element={<Navigate to="/" replace />} />
		</Routes>
		</>
	);
}
